/**
 * boost-instant-search-extension.js
 * Safely intercepts Boost Commerce's live search dropdown to inject custom logic
 * for Dummy Packages and Sealed Offer Events, without modifying core Boost files.
 */
(function() {
  function initBoostInstantSearchInterceptor() {
    if (typeof InstantSearchResultItemProduct !== 'undefined' && typeof InstantSearchResultItemProduct.prototype.compileTemplate === 'function') {
      var originalSearchCompileProd = InstantSearchResultItemProduct.prototype.compileTemplate;
      
      InstantSearchResultItemProduct.prototype.compileTemplate = function (data, index) {
        if (!data) data = this.data;
        if (!index) index = this.index;
        
        var html = originalSearchCompileProd.call(this, data, index);
        
        var tags = data.tags || [];
        var hasPackageTag = false;
        var isSealedOffer = false;
        var offerEndDate = '';
        
        tags.forEach(function(tag) {
          var t = tag.toLowerCase().trim();
          if (t === 'equipment package' || t === 'part of package') hasPackageTag = true;
          if (t === 'sealed offer event') isSealedOffer = true;
          if (t.indexOf('offer ends') > -1 || t.indexOf('sale ends') > -1) {
            var parts = t.split('ends');
            if (parts.length > 1) {
              var clean = parts[1].replace(':', '').trim();
              if (clean.charAt(0) === '-' || clean.charAt(0) === '–' || clean.charAt(0) === '—') {
                clean = clean.substring(1).trim();
              }
              offerEndDate = clean;
            }
          }
        });
        
        var variantPrice = data.price_min || 0;
        var comparePrice = data.compare_at_price_min || 0;
        var inventoryQuantity = 0;
        if (data.variants && data.variants.length > 0) {
          for (var i = 0; i < data.variants.length; i++) {
            inventoryQuantity += parseInt(data.variants[i].inventory_quantity, 10) || 0;
          }
        }
        var isOneDollar = (variantPrice === 100 || variantPrice === 1 || variantPrice === 1.00 || variantPrice === "1" || variantPrice === "1.00" || variantPrice === "100");
        
        var isDummyPackageItem = (hasPackageTag && isOneDollar && inventoryQuantity <= 0);

        var isExpired = false;
        if (offerEndDate) {
          var d = new Date(offerEndDate + 'T23:59:59');
          if (!isNaN(d.getTime()) && new Date() > d) {
            isExpired = true;
          }
        }

        if (isDummyPackageItem) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          
          var priceElements = doc.querySelectorAll('.boost-pfs-search-suggestion-product-price, .boost-pfs-search-suggestion-product-regular-price, .price, .product-price');
          if (priceElements && priceElements.length > 0) {
            priceElements[0].innerHTML = '<span style="text-transform: none; color: inherit;">Part of Package</span>';
          }
          return doc.body.innerHTML;
        } else if (isSealedOffer && comparePrice > variantPrice) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          
          var priceElements = doc.querySelectorAll('.boost-pfs-search-suggestion-product-price, .boost-pfs-search-suggestion-product-regular-price, .price, .product-price');
          if (priceElements && priceElements.length > 0) {
            if (isExpired) {
              priceElements[0].innerHTML = '<span style="font-weight: bold; font-size: 1.1em; color: var(--text-color);">OFFER ENDED</span>';
            } else {
              var testOutput = typeof Utils !== 'undefined' && Utils.formatMoney ? Utils.formatMoney(100) : '100';
              var isCents = testOutput.replace(/[^0-9]/g, '') === '100';
              var step = isCents ? 50000 : 500;
              
              var sliderMinRaw = (variantPrice * 0.55);
              var sliderMinRounded = Math.round(sliderMinRaw / step) * step;
              if (sliderMinRounded < step) sliderMinRounded = step;
              
              var formattedMin = typeof Utils !== 'undefined' && Utils.formatMoney 
                ? Utils.formatMoney(sliderMinRounded) 
                : (isCents ? '$' + (sliderMinRounded/100).toFixed(2) : '$' + sliderMinRounded.toFixed(2));
              
              priceElements[0].innerHTML = '<span style="display: block; font-size: 0.8em; font-weight: normal; opacity: 0.7; line-height: 1.1; margin-bottom: 2px;">Offers starting at</span><span class="price">' + formattedMin + '</span>';
            }
          }
          return doc.body.innerHTML;
        }
        
        return html;
      };
    }
  }

  // Bind to Boost's native initialization events
  if (typeof document !== 'undefined') {
    document.addEventListener('boost-pfs:rendered', function() {
      // In case we need to act after render
    });
    
    // We can also poll or wait for the objects to be available if they load late
    var checkBoostInterval = setInterval(function() {
      if (typeof InstantSearchResultItemProduct !== 'undefined') {
        initBoostInstantSearchInterceptor();
        clearInterval(checkBoostInterval);
      }
    }, 100);
    
    // Safety clear
    setTimeout(function() {
      clearInterval(checkBoostInterval);
    }, 5000);
  }
})();
